import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: {
    customerclasses: [],
    expensecategorys: [],
    paymentmethods: [],
    paymentterms: [],
    vendorclasses: [],
    currencys: [],
    royaltystatus: [],
    onixcontributorcodes: [],
    onixproductformcodes: [],
    onixsubjectcodes: [],
    onixsubjectschemes: [],
    onixproductavailabilitytypes: [],
    accountingMethod: 'paid', // Default, will be overridden
    enable_sales_by_region: false, // For consistency with other components
    enableSalesByRegion: false, // Keep for backwards compatibility
  },
}

export const publisherGlobalDataSlice = createSlice({
  name: 'publisherGlobalData',
  initialState,
  reducers: {
    setpublisherGlobalData: (state, action) => {
      // Convert enableSalesByRegion to enable_sales_by_region if present
      if (action.payload.hasOwnProperty('enableSalesByRegion')) {
        action.payload.enable_sales_by_region = action.payload.enableSalesByRegion;
      }

      state.value = { ...state.value, ...action.payload };
    },
    resetPublisherGlobalData: (state) => {
      state.value = initialState.value;
    },
    // Potentially add a specific reducer if needed, otherwise setpublisherGlobalData handles it
    // setEnableSalesByRegion: (state, action) => {
    //   state.value.enableSalesByRegion = action.payload;
    // },
  },
})

// Action creators are generated for each case reducer function
export const {
  setpublisherGlobalData,
  resetPublisherGlobalData,
  // setEnableSalesByRegion // Export if specific reducer is added
} = publisherGlobalDataSlice.actions;

export default publisherGlobalDataSlice.reducer;
